// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Footer_wrap__2Acfc","logo":"Footer_logo__1xFOM","inputDiv":"Footer_inputDiv__2jUYJ","email":"Footer_email__2eXnc","sub":"Footer_sub__2BZDf"};